<fullscreen-page>
  <dx-splitter>
    <dxi-splitter-item [collapsible]="true" size="33%">
      <navigation-column style="flex: 1 1;">
        <np-catalog-tree
            [catalogId]="catalogService.selectedCatalogId"
            [customerId]="getCustomerId()"
            [additionalFilter]="additionalFilter"
            [(searchText)]="searchText"
            [selectionMode]="treeListMode()"
            [selectionRecursive]="!isSearch(undefined)"
            [(selectedRowKeys)]="treeSelectedRowKeys"
            [showProductStateOptions]="true"
            [showSearchFormTab]="loginService.hasAddonSearchForm"
            [refreshWithSearchForm]="refreshWithSearchForm"
            [showContextMenu]="true"
            [menuItems]="menuItems"
            [footerButtons]="footerButtons"
            [showLanguageSelector]="showTranslateBox()"
            [languageFlags]="languageFlags"
            [(selectedTranslateLanguage)]="selectedTranslateLanguage"
            (onSelectionChanged)="onSelectItem($event)"
            (onRowClick)="onRowClickItem($event)"
            (onInitialized)="saveGridInstance($event)"
            (onContentReady)="onContentReady($event)"
            (onContextMenuShowing)="onContextMenuShowing($event.event, $event.item)"
            (onContextMenuItemClick)="itemClick($event.event, $event.item)"
            (onEditSearchForm)="toggleSearchFormPopup($event)">
        </np-catalog-tree>
      </navigation-column>
    </dxi-splitter-item>
    <dxi-splitter-item [collapsible]="true">
      <content-column look="light">
        <logo slot="toolbar" [routerLink]="['/catalogs']" look="light"></logo>

        <div slot="content" class="np-content-scroll">
          <catalogDetail *ngIf="isCatalogSelected && !massDataChange && !massGenerateKITexts" (onMassDataEdit)="setEmptyProduct($event)"></catalogDetail>
          <categoryDetail *ngIf="isCategorySelected && !massDataChange && !massGenerateKITexts" (onMassDataEdit)="setEmptyProduct($event)"></categoryDetail>
          <productDetail *ngIf="isProductSelected && !massDataChange && !massGenerateKITexts" (onMassDataEdit)="setEmptyProduct($event)"></productDetail>
          <massDataChange *ngIf="massDataChange" [treeList]="treeList" [emptyProduct]="emptyProduct" (cancel)="massCancel($event)"></massDataChange>
          <massGenerateKIText *ngIf="massGenerateKITexts" [treeList]="treeList" (cancel)="startMassGenerateKITexts()"></massGenerateKIText>
        </div>
      </content-column>
    </dxi-splitter-item>
  </dx-splitter>
</fullscreen-page>

<np-dialog [popupWidth]="500" [popupHeight]="300" [popupTitle]="'Info' | translate"
           [(popupVisible)]="showInfoForOnboardingUser">
  <div slot="content" class="w-100 h-100">
    <p>{{ 'Die Artikel des Katalogs sollten in die Zielstruktur überführt werden' | translate }}.</p>
    <p>{{ 'Hierzu können Sie die Funktion "Kataloge kombinieren verwenden' | translate }}."</p>

    <np-dialog-button slot="toolbar" toolbar="bottom" location="after" widget="dxButton"
                      [options]="{ stylingMode: 'outlined', text: 'Kataloge Kombinieren öffnen' | translate, onClick: showCombineCatalog }"></np-dialog-button>
    <np-dialog-button slot="toolbar" toolbar="bottom" location="after" widget="dxButton"
                      [options]="{ stylingMode: 'outlined', text: 'Später durchführen' | translate, onClick: hideInfoDialog }"></np-dialog-button>
  </div>
</np-dialog>

<np-dialog
    [popupWidth]="1250" [popupHeight]="800" [popupTitle]="'Suchformulare editieren / anlegen' | translate"
    [popupVisible]="searchFormPopupVisible"
    (popupVisibleChange)="onSearchFormPopupVisibleChange($event)">
    <div slot="content">
    <np-search-forms #searchFormsRef
        [initialSearchForm]="initialSearchForm"
        (saved)="onSearchFormSaved($event)"
        (cancelled)="searchFormPopupVisible = false"
    ></np-search-forms>

    <np-dialog-button slot="toolbar" toolbar="bottom" location="after" widget="dxButton"
                      [options]="{ stylingMode: 'outlined', icon: 'close', text: 'Abbrechen' | translate, onClick: onCancelSearchForm }"></np-dialog-button>
    <np-dialog-button slot="toolbar" toolbar="bottom" location="after" widget="dxButton"
                      [options]="{ type: 'default', icon: 'save', text: 'Speichern' | translate, disabled: readOnly('searchFormSave'), onClick: onSaveSearchForm }"></np-dialog-button>
    </div>
</np-dialog>